import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ShopSettingsService } from '../../general/services/shop-settings.service';
import { ConnectionService } from '../../../services/connection/connection.service';

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(
    private shopSettingsService: ShopSettingsService,
    private connectionService: ConnectionService,
    private router: Router,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.shopSettingsService.isWebshopMode) {
      this.router.navigate(['kiosk']);
      return false;
    }


    if (this.shopSettingsService.isVUMode) {
      if (this.connectionService.isAuthorizationTokenExist) {
        this.router.navigate(['/']);
      } else {
        this.router.navigate(['/maintenance']);
      }
      return false;
    }

    return true;
  }
}
